export const GlobalVariable = Object.freeze({
  /* TCFLEET LOCAL*/
/*  API_URL: "http://10.20.160.105:5000/api/v1.0",
  SOCKET_URL: "http://10.20.160.105:4999",
  BND_URL: "https://tcfleet.ngi.tn/bgis/bnd",
  TILE_URL: "https://tcfleet.ngi.tn/bgis/wms?format=png"*/

/* NGI GPS PROD 
API_URL: "https://app.ngi-gps.com/api/v1.0",
SOCKET_URL:'wss://app.ngi-gps.com', //socket io
BND_URL:"https://app.ngi-gps.com/bgis/bnd",
TILE_URL:"https://app.ngi-gps.com/bgis/wms?format=png"
*/
/* TC FLEET */
//  API_URL: "https://new.ngi-gps.com/ngifleet/api/v1.0",
//  SOCKET_URL:'wss://new.ngi-gps.com', //socket io
//  BND_URL:"https://new.ngi-gps.com/bgis/bnd",
//  TILE_URL: https://new.ngi-gps.com/bgis/wms?format=png"

//API_URL: "https://tcfleet.ngi.tn/api/v1.0",
//SOCKET_URL:'wss://tcfleet.ngi.tn', //socket io
//BND_URL:"https://tcfleet.ngi.tn/bgis/bnd",
//TILE_URL:"https://tcfleet.ngi.tn/bgis/wms?format=png"
/* NGI GPS DELICE */
//  API_URL: "http://41.224.35.21:7821/gps/api/v1.0",
// SOCKET_URL: "ws://41.224.35.21:7821/gps",
// BND_URL: "http://41.224.35.21:7821/bgis/bnd",
// TILE_URL: "http://ngi-gps.com/bgis/wms?format=png"
 

/* NGI GPS LUMIERE */
/* API_URL: "http://41.225.16.156:8086/api/v1.0",
SOCKET_URL: "ws://41.225.16.156:8086",
BND_URL: "http://ngi-gps.com/bgis/bnd",
TILE_URL: "http://ngi-gps.com/bgis/wms?format=png" */



/* TC FLEET CIV */
/*API_URL: "https://civ.tc-fleet.com/api/v1.0",
SOCKET_URL: "wss://civ.tc-fleet.com",
BND_URL: "https://civ.tc-fleet.com/bgis/bnd",
TILE_URL: "https://civ.tc-fleet.com/bgis/wms?format=png"*/

/* TC FLEET MAR */
API_URL: "https://mar.tc-fleet.com/api/v1.0",
SOCKET_URL: "wss://mar.tc-fleet.com",
BND_URL: "https://mar.tc-fleet.com/bgis/bnd",
TILE_URL: "https://mar.tc-fleet.com/bgis/wms?format=png",
HIDE_DISPUTEDBOUNDARIES:true


/* NGI GPS OrionCom */
/*API_URL: "https://orion-track.com/api/v1.0",
SOCKET_URL:'wss://orion-track.com', //socket io
BND_URL:"https://orion-track.com/bgis/bnd",
TILE_URL:"https://orion-track.com/bgis/wms?format=png"*/


});



// WEBPACK FOOTER //
// ./src/services/global.vars.ts